<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <div class="card-body settings-toggle-block">
          <div class="settings-toggle-block__label">
            <p class="category-title">Mini Sidebar</p>
            <p class="category">Show navigation panel on hover only.</p>
          </div>
          <div class="toggle">
            <base-switch
              id="miniSidebar"
              v-model="miniSidebar"
              type="primary"
              on-text="On"
              off-text="Off" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BaseSwitch } from 'src/components/UI';

export default {
  name: 'AccountSettings',
  components: {
    BaseSwitch,
  },
  props: {
    me: {
      type: Object,
      required: true,
    },
  },
  computed: {
    miniSidebar: {
      get() {
        return this.me.settings.mini_sidebar;
      },
      set(enabled) {
        this.$emit('updateSettings', { mini_sidebar: enabled });
      },
    },
  },
};
</script>
<style lang="scss">
.settings-toggle-block {
  display: flex;
}
.settings-toggle-block__label {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.toggle {
  display: flex;
  align-items: center;
}
</style>
